
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gqfg9tfnDw8jrZ0Tust_45sem1leUD4RM_fYTOgFz7YPWgMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexS6856dJGoLVNk4_45t_h6AyUNg0gFC7MI_45_0yXeo3W6NsMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchiceZXsildFsbncipFbv_rBfUmSKYOOAwkB5Wn0FV0FEMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexgMIEfhJEI_45fsJa4TRxwzRn1My303FqO9J3Qlu0lAnEEMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93VSR88HTQWR41eqkuprtybr6Qg_45aZkiOJ8uKotcW0_ZAMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index4_455Eh7XqppnVY9Mrxxr1OGKazz8t3_GwO9Ls5k0Npv8Meta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93CcV7ZOcF_CQYf5Wmc8tjoh8HEAXxosR7oviYC_ViiesMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexJLaYZ9RYnEqXzumTDIiqrTKhZEDxk1jP6bfP588Gfl8Meta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93fMfcw2_45IK8CPFM71A_45Rt7wcGlBgQTV2DT49plrgnyYYMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index4IVjY3oq7f7nxagepqDVjT_muJM1_gn8WkDveTgcn0UMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexfc_45xy1VzufiKegUIyt0f21iLoV_45L61f0mtdiAr_qG8cMeta } from "/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index4_455Eh7XqppnVY9Mrxxr1OGKazz8t3_GwO9Ls5k0Npv8Meta || {},
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexJLaYZ9RYnEqXzumTDIiqrTKhZEDxk1jP6bfP588Gfl8Meta || {},
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index4IVjY3oq7f7nxagepqDVjT_muJM1_gn8WkDveTgcn0UMeta || {},
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexfc_45xy1VzufiKegUIyt0f21iLoV_45L61f0mtdiAr_qG8cMeta || {},
    component: () => import("/codebuild/output/src3984101083/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]